import * as React from 'react';
import '../Chat/app.scss';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { Container } from '../Container';
import { MessageContainer } from '../../Containers/MessageContainer';
import { AuthContext } from '../../contexts/AuthContext';
import separator_ from '../../assets/images/separator.svg';
import * as LangConfig from '../../languages/languages';

export const PrivacyPolicy: React.FC = (props) => {
	const auth = React.useContext(AuthContext);
	const [translations, setTranslations] = React.useState(auth['user']['attributes'].locale ? LangConfig.languages[auth['user']['attributes'].locale]['translations'] : LangConfig.languages['en']['translations']);

	return (
		<MessageContainer
			render={({ messages, setMessages, resetSession, useOldSession }) => (
				<>
					<div>
						{auth && auth.hasValidSession ? <Header resetSession={resetSession} /> : <Container> <div className="navigation"><Navbar collapseOnSelect expand="lg" className="p-0 d-flex justify-content-start navbar-expand">
							<Navbar.Brand className="">
								{<Nav.Link href="/"> <svg width="67" height="23" viewBox="0 0 67 23" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.56 11.4C0.56 10.2533 0.773333 9.24667 1.2 8.38C1.64 7.51333 2.23333 6.84667 2.98 6.38C3.72667 5.91333 4.56 5.68 5.48 5.68C6.26667 5.68 6.95333 5.84 7.54 6.16C8.14 6.48 8.6 6.9 8.92 7.42V5.84H12.34V17H8.92V15.42C8.58667 15.94 8.12 16.36 7.52 16.68C6.93333 17 6.24667 17.16 5.46 17.16C4.55333 17.16 3.72667 16.9267 2.98 16.46C2.23333 15.98 1.64 15.3067 1.2 14.44C0.773333 13.56 0.56 12.5467 0.56 11.4ZM8.92 11.42C8.92 10.5667 8.68 9.89333 8.2 9.4C7.73333 8.90667 7.16 8.66 6.48 8.66C5.8 8.66 5.22 8.90667 4.74 9.4C4.27333 9.88 4.04 10.5467 4.04 11.4C4.04 12.2533 4.27333 12.9333 4.74 13.44C5.22 13.9333 5.8 14.18 6.48 14.18C7.16 14.18 7.73333 13.9333 8.2 13.44C8.68 12.9467 8.92 12.2733 8.92 11.42ZM21.0342 14.1V17H19.2942C18.0542 17 17.0876 16.7 16.3942 16.1C15.7009 15.4867 15.3542 14.4933 15.3542 13.12V8.68H13.9942V5.84H15.3542V3.12H18.7742V5.84H21.0142V8.68H18.7742V13.16C18.7742 13.4933 18.8542 13.7333 19.0142 13.88C19.1742 14.0267 19.4409 14.1 19.8142 14.1H21.0342ZM24.6392 4.68C24.0392 4.68 23.5459 4.50667 23.1592 4.16C22.7859 3.8 22.5992 3.36 22.5992 2.84C22.5992 2.30667 22.7859 1.86667 23.1592 1.52C23.5459 1.16 24.0392 0.979999 24.6392 0.979999C25.2259 0.979999 25.7059 1.16 26.0792 1.52C26.4659 1.86667 26.6592 2.30667 26.6592 2.84C26.6592 3.36 26.4659 3.8 26.0792 4.16C25.7059 4.50667 25.2259 4.68 24.6392 4.68ZM26.3592 18.44C26.3592 19.8133 26.0126 20.8 25.3192 21.4C24.6259 22.0133 23.6592 22.32 22.4192 22.32H21.0792V19.42H21.8992C22.2726 19.42 22.5392 19.3467 22.6992 19.2C22.8592 19.0533 22.9392 18.8133 22.9392 18.48V5.84H26.3592V18.44ZM32.2381 7.42C32.5581 6.9 33.0181 6.48 33.6181 6.16C34.2181 5.84 34.9048 5.68 35.6781 5.68C36.5981 5.68 37.4315 5.91333 38.1781 6.38C38.9248 6.84667 39.5115 7.51333 39.9381 8.38C40.3781 9.24667 40.5981 10.2533 40.5981 11.4C40.5981 12.5467 40.3781 13.56 39.9381 14.44C39.5115 15.3067 38.9248 15.98 38.1781 16.46C37.4315 16.9267 36.5981 17.16 35.6781 17.16C34.8915 17.16 34.2048 17.0067 33.6181 16.7C33.0315 16.38 32.5715 15.96 32.2381 15.44V17H28.8181V2.2H32.2381V7.42ZM37.1181 11.4C37.1181 10.5467 36.8781 9.88 36.3981 9.4C35.9315 8.90667 35.3515 8.66 34.6581 8.66C33.9781 8.66 33.3981 8.90667 32.9181 9.4C32.4515 9.89333 32.2181 10.5667 32.2181 11.42C32.2181 12.2733 32.4515 12.9467 32.9181 13.44C33.3981 13.9333 33.9781 14.18 34.6581 14.18C35.3381 14.18 35.9181 13.9333 36.3981 13.44C36.8781 12.9333 37.1181 12.2533 37.1181 11.4ZM47.4723 17.16C46.379 17.16 45.3923 16.9267 44.5123 16.46C43.6457 15.9933 42.959 15.3267 42.4523 14.46C41.959 13.5933 41.7123 12.58 41.7123 11.42C41.7123 10.2733 41.9657 9.26667 42.4723 8.4C42.979 7.52 43.6723 6.84667 44.5523 6.38C45.4323 5.91333 46.419 5.68 47.5123 5.68C48.6057 5.68 49.5923 5.91333 50.4723 6.38C51.3523 6.84667 52.0457 7.52 52.5523 8.4C53.059 9.26667 53.3123 10.2733 53.3123 11.42C53.3123 12.5667 53.0523 13.58 52.5323 14.46C52.0257 15.3267 51.3257 15.9933 50.4323 16.46C49.5523 16.9267 48.5657 17.16 47.4723 17.16ZM47.4723 14.2C48.1257 14.2 48.679 13.96 49.1323 13.48C49.599 13 49.8323 12.3133 49.8323 11.42C49.8323 10.5267 49.6057 9.84 49.1523 9.36C48.7123 8.88 48.1657 8.64 47.5123 8.64C46.8457 8.64 46.2923 8.88 45.8523 9.36C45.4123 9.82667 45.1923 10.5133 45.1923 11.42C45.1923 12.3133 45.4057 13 45.8323 13.48C46.2723 13.96 46.819 14.2 47.4723 14.2ZM61.3467 14.1V17H59.6067C58.3667 17 57.4001 16.7 56.7067 16.1C56.0134 15.4867 55.6667 14.4933 55.6667 13.12V8.68H54.3067V5.84H55.6667V3.12H59.0867V5.84H61.3267V8.68H59.0867V13.16C59.0867 13.4933 59.1667 13.7333 59.3267 13.88C59.4867 14.0267 59.7534 14.1 60.1267 14.1H61.3467ZM64.8517 17.16C64.2517 17.16 63.7584 16.9867 63.3717 16.64C62.9984 16.28 62.8117 15.84 62.8117 15.32C62.8117 14.7867 62.9984 14.34 63.3717 13.98C63.7584 13.62 64.2517 13.44 64.8517 13.44C65.4384 13.44 65.9184 13.62 66.2917 13.98C66.6784 14.34 66.8717 14.7867 66.8717 15.32C66.8717 15.84 66.6784 16.28 66.2917 16.64C65.9184 16.9867 65.4384 17.16 64.8517 17.16Z" fill="#333333" />
								</svg> </Nav.Link>}
							</Navbar.Brand></Navbar></div></Container>}
						<div className="default_page">
							<div className="app-main">
								<div className="app-main-inner">
									<Container>
										<div className="row justify-content-center">
											<div className="col-12 col-sm-10">
												<div className="default_page_box">
													<div className="default_page_header">
														<h2><strong>{translations.Privacy_Policy}</strong> <span><small>{translations.Effective_Date}:</small> August 15, 2018</span></h2>
													</div>
													<div className="default_page_content">
														<p>{translations.privacy_1}</p>
														<p>{translations.privacy_2}</p>
														<p>{translations.privacy_3}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Definitions}</h3>
														<h4>{translations.Service}</h4>
														<p>{translations.privacy_4}</p>
														<h4>{translations.Personal_Data}</h4>
														<p>{translations.privacy_5}</p>
														<h4>{translations.Usage_Data}</h4>
														<p>{translations.privacy_6}</p>
														<h4>{translations.Cookies}</h4>
														<p>{translations.privacy_7}</p>
														<h4>{translations.data_controller}</h4>
														<p>{translations.privacy_8}</p>
														<p>{translations.privacy_9}</p>
														<h4>{translations.data_processors}</h4>
														<p>{translations.privacy_10}</p>
														<p>{translations.privacy_11}</p>
														<h4>{translations.data_subject}</h4>
														<p>{translations.privacy_12}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.information_collection}</h3>
														<p>{translations.privacy_13}</p>
														<h4>{translations.types_collected}</h4>

													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Personal_Data}</h3>
														<p>{translations.privacy_14}:</p>
														<ul>
															<li>{translations.privacy_15}</li>
															<li>{translations.privacy_16}</li>
															<li>{translations.privacy_17}</li>
															<li>{translations.privacy_18}</li>
															<li>{translations.privacy_19}</li>
														</ul>
														<p>{translations.privacy_20}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Usage_Data}</h3>
														<p>{translations.privacy_21}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Location_Data}</h3>
														<p>{translations.privacy_22}</p>
														<p>{translations.privacy_23}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Tracking} &amp; {translations.Cookies_Data}</h3>
														<p>{translations.privacy_24}</p>
														<p>{translations.privacy_25}</p>
														<p>{translations.privacy_26}</p>
														{/* <p>Examples of Cookies we use:</p>
														<ul>
															<li><strong>Session Cookies.</strong> We use Session Cookies to operate our Service.</li>
															<li><strong>Preference Cookies.</strong> We use Preference Cookies to remember your preferences and various settings.</li>
															<li><strong>Security Cookies.</strong> We use Security Cookies for security purposes.</li>
														</ul> */}
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Use_of_Data}</h3>
														<p>{translations.privacy_27}:</p>
														<ul>
															<li>{translations.privacy_28}</li>
															<li>{translations.privacy_29}</li>
															<li>{translations.privacy_30}</li>
															<li>{translations.privacy_31}</li>
															{/* <li>To gather analysis or valuable information so that we can improve our Service</li>
															<li>To monitor the usage of our Service</li>
															<li>To detect, prevent and address technical issues</li> */}
															<li>{translations.privacy_32}</li>
														</ul>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.privacy_33}</h3>
														<p>{translations.privacy_34}</p>
														<p>{translations.privacy_35}:</p>
														<ul>
															<li>{translations.privacy_36}</li>
															<li>{translations.privacy_37}</li>
															<li>{translations.privacy_38}</li>
															{/* <li>For payment processing purposes</li>
															<li>To comply with the law</li> */}
														</ul>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Retention_of_Data}</h3>
														<p>{translations.privacy_39}</p>
														<p>{translations.privacy_40}</p>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Transfer_of_Data}</h3>
														<p>{translations.privacy_41}</p>
														<p>{translations.privacy_42}</p>
														{/* <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p> */}
														<p>{translations.privacy_43}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Disclosure_of_Data}</h3>
														<h4>{translations.Business_Transaction}</h4>
														<p>{translations.privacy_44}</p>
														<h4>{translations.law_enf}</h4>
														<p>{translations.privacy_45}</p>
														<h4>{translations.Legal_Requirements}</h4>
														<p>{translations.privacy_46}:</p>
														<ul>
															<li>{translations.privacy_47}</li>
															<li>{translations.privacy_48}</li>
															<li>{translations.privacy_49}</li>
															<li>{translations.privacy_50}</li>
															{/* <li>To protect against legal liability</li> */}
														</ul>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Security_of_Data}</h3>
														<p>{translations.privacy_51}</p>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.privacy_52}</h3>
														<p>{translations.privacy_53}</p>
														<p>{translations.privacy_54}</p>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.privacy_55}</h3>
														<p>{translations.privacy_56}</p>
														<p>{translations.privacy_57}</p>
														<p>{translations.privacy_58}:</p>
														<ul>
															<li>
																<p>{translations.privacy_59}</p>
															</li>
															<li>
																<p>{translations.privacy_60}</p>
															</li>
															<li>
																<p>{translations.privacy_61}</p>
															</li>
															<li>
																<p>{translations.privacy_62}</p>
															</li>
															<li>
																<p>{translations.privacy_63}</p>
															</li>
															<li>
																<p>{translations.privacy_64}</p>
															</li>
														</ul>
														<p>{translations.privacy_65}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.privacy_66}</h3>
														<p>{translations.privacy_67}</p>
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Service_Providers}</h3>
														<p>{translations.privacy_68}</p>
														<p>{translations.privacy_69}</p>
														<h4>{translations.Analytics}</h4>
														<p>{translations.privacy_70}</p>
														<ul>
															<li>
																<p><strong>{translations.Google_Analytics}</strong>
																</p>
																<p>{translations.privacy_71}</p>
																<p>{translations.privacy_72}</p>
																{/* <p>For more information on the privacy practices of Google, please visit the Google Privacy &amp; Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
																</p> */}
															</li>
															{/* <li>
																<p><strong>Mixpanel</strong>
																</p>
																<p>Mixpanel is provided by Mixpanel Inc.</p>
																<p>You can prevent Mixpanel from using your information for analytics purposes by opting-out. To opt-out of Mixpanel service, please visit this page: <a href="https://mixpanel.com/optout/">https://mixpanel.com/optout/</a>
																</p>
																<p>For more information on what type of information Mixpanel collects, please visit the Terms of Use page of Mixpanel: <a href="https://mixpanel.com/terms/">https://mixpanel.com/terms/</a>
																</p>
															</li> */}
														</ul>
														{/* <h4>Behavioral Remarketing</h4>
														<p>LawDroid Ltd. uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.</p>
														<ul>
															<li>
																<p><strong>Google AdWords</strong>
																</p>
																<p>Google AdWords remarketing service is provided by Google Inc.</p>
																<p>You can opt-out of Google Analytics for Display Advertising and customise the Google Display Network ads by visiting the Google Ads Settings page: <a href="http://www.google.com/settings/ads">http://www.google.com/settings/ads</a>
																</p>
																<p>Google also recommends installing the Google Analytics Opt-out Browser Add-on - <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a> - for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.</p>
																<p>For more information on the privacy practices of Google, please visit the Google Privacy &amp; Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
																</p>
															</li>
															<li>
																<p><strong>Twitter</strong>
																</p>
																<p>Twitter remarketing service is provided by Twitter Inc.</p>
																<p>You can opt-out from Twitter's interest-based ads by following their instructions: <a href="https://support.twitter.com/articles/20170405">https://support.twitter.com/articles/20170405</a>
																</p>
																<p>You can learn more about the privacy practices and policies of Twitter by visiting their Privacy Policy page: <a href="https://twitter.com/privacy">https://twitter.com/privacy</a>
																</p>
															</li>
															<li>
																<p><strong>Facebook</strong>
																</p>
																<p>Facebook remarketing service is provided by Facebook Inc.</p>
																<p>You can learn more about interest-based advertising from Facebook by visiting this page: <a href="https://www.facebook.com/help/164968693837950">https://www.facebook.com/help/164968693837950</a>
																</p>
																<p>To opt-out from Facebook's interest-based ads, follow these instructions from Facebook: <a href="https://www.facebook.com/help/568137493302217">https://www.facebook.com/help/568137493302217</a>
																</p>
																<p>Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA <a href="http://www.aboutads.info/choices/">http://www.aboutads.info/choices/</a>, the Digital Advertising Alliance of Canada in Canada <a href="http://youradchoices.ca/">http://youradchoices.ca/</a> or the European Interactive Digital Advertising Alliance in Europe <a href="http://www.youronlinechoices.eu/">http://www.youronlinechoices.eu/</a>, or opt-out using your mobile device settings.</p>
																<p>For more information on the privacy practices of Facebook, please visit Facebook's Data Policy: <a href="https://www.facebook.com/privacy/explanation">https://www.facebook.com/privacy/explanation</a>
																</p>
															</li>
														</ul>
														<h4>Payments</h4>
														<p>We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors).</p>
														<p>We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.</p>
														<p>The payment processors we work with are:</p>
														<ul>
															<li>
																<p><strong>Stripe</strong>
																</p>
																<p>Their Privacy Policy can be viewed at <a href="https://stripe.com/us/privacy">https://stripe.com/us/privacy</a>
																</p>
															</li>
														</ul> */}
													</div>
													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Links_to_Other_Sites}</h3>
														<p>{translations.privacy_73}</p>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.c_privacy}</h3>
														<p>{translations.privacy_74}</p>
														<p>{translations.privacy_75}</p>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Changes_to_This_Privacy_Policy}</h3>
														<p>{translations.privacy_76}</p>
														<p>{translations.privacy_77}</p>
														<p>{translations.privacy_78}</p>
													</div>

													<div className="default_page_space"><img src={separator_} /></div>
													<div className="default_page_content">
														<h3>{translations.Contact_Us}</h3>
														<p>{translations.privacy_79}:</p>
														<ul>
															<li>{translations.privacy_80}: <a href="mailto:privacy@lawdroid.com">privacy@lawdroid.com</a></li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</Container>
								</div>
							</div>
						</div>
						<Footer />
					</div>
				</>
			)}
		/>
	);
};
